<template>
  <div>
    <b-row>
      <b-col>
        <ulu-date-picker
          class="float-right"
          range
          v-model="range"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.all')"
        />
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col cols="12" md="6" lg="4" class="mt-1">
        <ulu-inquiry-details-card :range="formatedRange" />
      </b-col>
      <b-col ccols="12" md="6" lg="4" class="mt-1">
        <ulu-order-details-card :range="formatedRange" />
      </b-col>
      <b-col cols="12" md="6" lg="4" class="mt-1">
        <ulu-invoice-details-card :range="formatedRange" />
      </b-col>
      <b-col cols="12" md="6" lg="4" class="mt-1">
        <ulu-device-details-card :range="formatedRange" />
      </b-col>
      <b-col cols="12" md="6" lg="4" class="mt-1">
        <ulu-customer-details-card :range="formatedRange" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  components: {
    "ulu-date-picker": DatePicker,
    "ulu-order-details-card": () =>
      import("@/components/dashboard/details/DetailsOrder.vue"),
    "ulu-inquiry-details-card": () =>
      import("@/components/dashboard/details/DetailsInquiry.vue"),
    "ulu-invoice-details-card": () =>
      import("@/components/dashboard/details/DetailsInvoice.vue"),
    "ulu-device-details-card": () =>
      import("@/components/dashboard/details/DetailsDevice.vue"),
    "ulu-customer-details-card": () =>
      import("@/components/dashboard/details/DetailsCustomer.vue")
  },
  data() {
    return {
      range: [null, null],
      formatedRange: [null, null]
    };
  },
  watch: {
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        this.formatedRange = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];
      } else {
        this.formatedRange = [null, null];
      }
    }
  }
};
</script>
